import { FC } from "react";
import { ProgressBar } from "components/controls/progressBar";
import { AnimatePresence, motion } from "framer-motion";
import { Box } from "@chakra-ui/react";

type Props = {
  percent: number;
}

export const DropFileInProgress: FC<Props> = ({ percent }) => (
  <AnimatePresence>
    {(percent > 0)  && (
      <Box
        as={motion.div}
        position={"absolute"}
        top={'50%'}
        left={5}
        right={5}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <ProgressBar percent={percent} />
      </Box>
    )}
  </AnimatePresence>
);
